import { get, post } from 'src/tools/server';

// 获取页面country/region 和phone 的area 的接口
export const getPickupLocationPage = () => {
  return get<any>(`/portal/setting/store/logistics/pickupLocation/page`, {});
};

// onSave
export const setPickupLocation = (body: any) => {
  return post<any>(`/portal/setting/store/logistics/pickupLocation`, body, {});
};

// 获取地址经纬度
export const getPickupLocationGeo = (body: any) => {
  return post<any>(
    `/portal/setting/store/logistics/pickupLocation/geo`,
    body,
    {},
  );
};

// 获取pickupLocation 列表
export const getPickupLocations = () => {
  return get<any>(`/portal/setting/store/logistics/pickupLocations`, {});
};

// setActive
export const setPickupLocationActivate = (uuid) => {
  return get<any>(
    `/portal/setting/store/logistics/pickupLocation/activate/${uuid}`,
    {},
  );
};

// setDeActive
export const setPickupLocationDeactivate = (uuid) => {
  return get<any>(
    `/portal/setting/store/logistics/pickupLocation/deactivate/${uuid}`,
    {},
  );
};
// detail
export const getPickupLocation = (uuid) => {
  return get<any>(`/portal/setting/store/logistics/pickupLocation/${uuid}`, {});
};

// 设置排序
export const setPickupLocationOrder = (body: any) => {
  return post<any>(
    `/portal/setting/store/logistics/pickupLocation/order`,
    body,
    {},
  );
};
